module.exports = __webpack_public_path__ + "static/img/20.b39f4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/20.png
// module id = 2E4y
// module chunks = 0